import NotificationBadge from "./notificationBadge.container";

export default NotificationBadge;
